import { render } from "./StakeInput.vue?vue&type=template&id=1bed7ffa"
import script from "./StakeInput.vue?vue&type=script&setup=true&lang=js"
export * from "./StakeInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/stake/StakeInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bed7ffa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bed7ffa', __exports__)) {
    api.reload('1bed7ffa', __exports__)
  }
  
  module.hot.accept("./StakeInput.vue?vue&type=template&id=1bed7ffa", () => {
    api.rerender('1bed7ffa', render)
  })

}


export default __exports__